import { useQuery } from "@tanstack/react-query";
import { getModels } from "@/lib/api/gateway";
import { keys } from "./keys";

/** The models the envoy may think with, cheapest first, with which the person may pick. */
export function useModels() {
    return useQuery({ queryKey: keys.gateway.models, queryFn: getModels, staleTime: 10 * 60_000 });
}
